import { type FC } from 'react';
import { FiUser } from 'react-icons/fi';
import { FIELD_LABEL_CLASS, INPUT_CLASS } from '../../pages/Onboarding/OnboardingUI';

interface DisplayNameFieldProps {
    id: string
    value: string
    error?: string
    disabled?: boolean
    onChange: (value: string) => void
    onBlur?: (value: string) => void
}

// The display name control from Edit Profile. Settings uses the same field.
const DisplayNameField: FC<DisplayNameFieldProps> = ({
    id,
    value,
    error,
    disabled = false,
    onChange,
    onBlur,
}) => (
    <div>
        <label className={FIELD_LABEL_CLASS} htmlFor={id}>
            Display name
        </label>
        <div className="relative">
            <FiUser className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" aria-hidden />
            <input
                id={id}
                type="text"
                value={value}
                maxLength={30}
                placeholder="Your name or artist name"
                disabled={disabled}
                aria-invalid={error ? true : undefined}
                onChange={(event) => onChange(event.target.value)}
                onBlur={(event) => onBlur?.(event.target.value)}
                className={`${INPUT_CLASS} ${error ? '!border-red-500' : ''}`}
            />
        </div>
        {error && (
            <p className="mt-1.5 text-sm text-red-500" role="alert">
                {error}
            </p>
        )}
    </div>
);

export default DisplayNameField;
